import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import RelatedArticlesSection from '../Components/news/RelatedArticlesSection'
import LatestNewsSection from '../Components/news/LatestNewsSection'
import { Helmet } from "react-helmet-async";

function News() {
    return (
        <div>
            <Helmet>
    <title>
        News & Media | Latest News, Updates & Insights | Mobikode
    </title>

    <meta
        name="description"
        content="Stay updated with the latest Mobikode news, media updates, company announcements, technology insights, Enterprise AI & ServiceNow Consulting developments, and industry highlights."
    />

    <meta
        name="keywords"
        content="Mobikode News, Mobikode Media, News And Media, Mobikode News and Updates, Technology News, Enterprise AI & ServiceNow Consulting News, IT Company News, Technology Insights, Company Announcements, Industry News, Digital Technology Updates, Mobikode Latest News"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/news"
    />

    <meta
        property="og:title"
        content="News & Media | Latest News, Updates & Insights | Mobikode"
    />

    <meta
        property="og:description"
        content="Explore the latest news, media updates, announcements, technology insights, and industry developments from Mobikode."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/news"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/news/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="News & Media | Latest News, Updates & Insights | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Keep up with Mobikode's latest news, company updates, technology insights, media coverage, and industry developments."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/news/bg1.png"
    />
</Helmet>
            <WhoHero
                title="News And Media"
                text="Technology. Transformation. Trust."
                imgData="/assets/news/bg1.png"
            />
            <RelatedArticlesSection />
            <LatestNewsSection />
        </div>
    )
}

export default News
